import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import ExpressShippingPage from "./pages/ExpressShippingPage";
import GetQuotePage from "./pages/GetQuotePage";
import LinksPage from "./pages/LinksPage";
import PartnerPage from "./pages/PartnerPage";
import PolicyPage from "./pages/PolicyPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import AdminPage from "./pages/AdminPage";
import WhatsAppFloat from "./components/WhatsAppFloat";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/express-shipping" element={<ExpressShippingPage />} />
          <Route path="/get-quote" element={<GetQuotePage />} />
          <Route path="/links" element={<LinksPage />} />
          <Route path="/partner" element={<PartnerPage />} />
          <Route path="/policy" element={<PolicyPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <WhatsAppFloat />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
